import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nfts/shape.png'


const _hoisted_1 = {
  class: "trezo-card mb-[25px] p-[20px] md:p-[25px] relative z-[1] rounded-md",
  style: {"background":"linear-gradient(92deg, #23272e 7.31%, #3f5272 97.89%)"}
}
const _hoisted_2 = { class: "trezo-card-content md:py-[33px] md:px-[15px] lg:flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "text-white text-xl md:text-2xl mb-[5px]" }, " Manage Your NFT From One Place "),
        _createElementVNode("p", { class: "text-gray-300" }, " The world’s first and largest digital marketplace for discover, collect, sell and create your own NFTs. ")
      ], -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_RouterLink, {
          to: "/nft-marketplace/create-nft",
          class: "text-[15px] md:text-md mt-[15px] lg:mt-0 rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[30px] transition-all hover:bg-primary-400 inline-block"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Create NFT ")
          ])),
          _: 1
        })
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      class: "absolute top-0 ltr:right-0 rtl:left-0 -z-[1]",
      alt: "shape"
    }, null, -1))
  ]))
}